// This file needs to be in sync with the same file on api side

export enum ELEMENT {
    STATIC_TEXT = 'STATIC_TEXT',
    HTML = 'HTML',
    STATIC_LIST = 'STATIC_LIST',
    STATIC_TABLE_V2 = 'STATIC_TABLE_V2',
    IMAGE = 'IMAGE',
    IMAGE_GALLERY = 'IMAGE_GALLERY',
    VIDEO = 'VIDEO',

    QUESTION = 'QUESTION',
    YES_NO_QUESTION_V2 = 'YES_NO_QUESTION_V2',
    MULTI_SELECT = 'MULTI_SELECT',
    PHOTO_ANSWER_QUESTION = 'PHOTO_ANSWER_QUESTION',
    SEQUENCE_QUESTION = 'SEQUENCE_QUESTION',
    MATCH_PAIR_QUESTION = 'MATCH_PAIR_QUESTION',
    IMAGE_MARKUP = 'IMAGE_MARKUP',
    LIKERT_SCALE = 'LIKERT_SCALE',

    QUESTION_REPORT = 'QUESTION_REPORT',

    ELLIPSE = 'ELLIPSE',
    TRIANGLE = 'TRIANGLE',
    RECTANGLE = 'RECTANGLE',
    STAR = 'STAR',
    LINE_V2 = 'LINE_V2',
    ARROW_V2 = 'ARROW_V2',

    BUTTON = 'BUTTON',
    STATUS = 'STATUS',
    TEXT_INPUT = 'TEXT_INPUT',
    FORM = 'FORM_ELEMENT',
    MODAL = 'MODAL_ELEMENT',
    FLIP_CARD = 'FLIP_CARD',
    CALCULATOR = 'CALCULATOR',
    CHATBOT = 'CHATBOT',

    // EDITOR ONLY START
    PLACEHOLDER = 'PLACEHOLDER',
    // EDITOR ONLY END

    // Deprecated
    /**
     * @deprecated Use STATIC_TABLE_V2 instead.
     */
    STATIC_TABLE = 'STATIC_TABLE',
    /**
     * @deprecated Use YES_NO_QUESTION_V2 instead.
     */
    YES_NO_QUESTION = 'YES_NO_QUESTION',
    /**
     * @deprecated Use LINE_V2 instead.
     */
    LINE = 'LINE_V1',
    /**
     * @deprecated Use ARROW_V2 instead.
     */
    ARROW = 'ARROW_V1',
    /**
     * @deprecated Use ELLIPSE instead.
     */
    CIRCLE = 'CIRCLE',
}

export const clickableElementTypes = [
    ELEMENT.STATIC_TEXT,
    ELEMENT.HTML,
    ELEMENT.STATIC_LIST,
    ELEMENT.STATIC_TABLE,
    ELEMENT.STATIC_TABLE_V2,
    ELEMENT.IMAGE,
    ELEMENT.VIDEO,
    ELEMENT.RECTANGLE,
    ELEMENT.CIRCLE,
    ELEMENT.ELLIPSE,
    ELEMENT.TRIANGLE,
    ELEMENT.STAR,
    ELEMENT.LINE,
    ELEMENT.LINE_V2,
    ELEMENT.ARROW,
    ELEMENT.ARROW_V2,
    ELEMENT.BUTTON,
    ELEMENT.LIKERT_SCALE,
];

export const interactiveElementTypes = [
    ELEMENT.QUESTION,
    ELEMENT.MULTI_SELECT,
    ELEMENT.YES_NO_QUESTION,
    ELEMENT.YES_NO_QUESTION_V2,
    ELEMENT.PHOTO_ANSWER_QUESTION,
    ELEMENT.SEQUENCE_QUESTION,
    ELEMENT.MATCH_PAIR_QUESTION,
    ELEMENT.IMAGE_MARKUP,
    ELEMENT.LIKERT_SCALE,
    ELEMENT.TEXT_INPUT,
];

export const interactiveWithTryButton = [ELEMENT.QUESTION, ELEMENT.PHOTO_ANSWER_QUESTION];

export const retryableQuestions = [
    ELEMENT.QUESTION,
    ELEMENT.MULTI_SELECT,
    ELEMENT.PHOTO_ANSWER_QUESTION,
    ELEMENT.SEQUENCE_QUESTION,
    ELEMENT.IMAGE_MARKUP,
    ELEMENT.MATCH_PAIR_QUESTION,
];

export const baseElementTypes = [ELEMENT.STATIC_TEXT, ELEMENT.STATIC_TABLE_V2, ELEMENT.HTML];

export const formsElementTypes = [ELEMENT.TEXT_INPUT, ELEMENT.FORM, ELEMENT.BUTTON];

export const mediaElementTypes = [ELEMENT.IMAGE, ELEMENT.VIDEO, ELEMENT.IMAGE_GALLERY];

export const questionElementTypes = [
    ELEMENT.QUESTION,
    ELEMENT.YES_NO_QUESTION_V2,
    ELEMENT.MULTI_SELECT,
    ELEMENT.PHOTO_ANSWER_QUESTION,
    ELEMENT.IMAGE_MARKUP,
    ELEMENT.SEQUENCE_QUESTION,
    ELEMENT.MATCH_PAIR_QUESTION,
    ELEMENT.LIKERT_SCALE,
    ELEMENT.YES_NO_QUESTION,
];

export const shapeElementTypes = [ELEMENT.RECTANGLE, ELEMENT.ELLIPSE, ELEMENT.TRIANGLE, ELEMENT.STAR, ELEMENT.LINE_V2, ELEMENT.ARROW_V2];

export const otherElementTypes = [ELEMENT.CALCULATOR, ELEMENT.FLIP_CARD, ELEMENT.MODAL, ELEMENT.CHATBOT];
